import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Venue Management ',
  addTitle: ' Venue',
  url: 'venue',
  ...Routes.Venue
};

export default shared;
